// components/WhatsAppButton.jsx
import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppButton = ({ phoneNumber = "989155838178", message = "سلام! برای سفارش قهوه راهنمایی می‌خواهم." }) => {
    const encodedMessage = encodeURIComponent(message);
    const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

    return (
        <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-6 right-6 z-50 flex items-center justify-center bg-green-500 hover:bg-green-600 text-white w-14 h-14 rounded-full shadow-lg transition-colors duration-200 animate-bounce"
            aria-label="Chat on WhatsApp"
        >
            <FaWhatsapp className="text-2xl" />
        </a>
    );
};

export default WhatsAppButton;
